module.exports = __webpack_public_path__ + "img/meal_kit_delivery2.7924cd46.jpg";